// @flow
import React from "react";
import {
    Typography,
    MenuItem,
    FormControlLabel,
    withStyles,
    Radio,
    Button,
    Box,
} from "@material-ui/core";
import { Field, reduxForm } from "redux-form";
import { compose } from "redux";
import { connect } from "react-redux";
import RFInputField from "../components/RFInputField";
import RFRadioButtonGroup from "../components/RFRadioButtonGroup";
import RFCheckboxGroup from "../components/RFCheckboxGroup";
import validate from "../utils/validate";
import type { NetworkType } from "../../../core/entities/networkType.type";
import type { StructureType } from "../../../core/entities/structureType.type";
import styles from "../styles/styles";
import RFSelectField from "../components/RFSelectField";

const toInt = value => {
    if (value < 0 || value == null) {
        return 0;
    }
    return parseInt(value, 10);
};

type Props = {
    handleSubmit: Function,
    networkTypes: Array<?NetworkType>,
    structureTypes: Array<StructureType>,
    classes: Object,
    created: string,
    reset: Function,
    previousPage: Function,
    valid: boolean,
};

const SecondPage = (props: Props) => {
    const {
        handleSubmit,
        structureTypes,
        networkTypes,
        valid,
        classes,
        created,
        reset,
        previousPage,
    } = props;

    if (created) {
        reset("event");
    }

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Box>
                    <Typography variant="h3" className="main__title">
                        Informations sur l’organisateur
                    </Typography>
                    <Typography
                        variant=" "
                        className={[classes.spacingUp, "form__title"].join(" ")}
                    >
                        Structure ou particulier responsable de l’animation
                    </Typography>
                    <Field
                        name="structureName"
                        component={RFInputField}
                        label="Nom et prénom du particulier ou nom de la structure"
                        type="text"
                        required
                    />
                    <Field
                        name="ownerPartner"
                        component={RFInputField}
                        label="En partenariat avec"
                        type="text"
                    />
                    <Field
                        name="ownerPrivateFirstname"
                        component={RFInputField}
                        label="Prénom"
                        type="text"
                    />
                    <Field
                        name="ownerPrivateLastname"
                        component={RFInputField}
                        label="Nom"
                        type="text"
                    />
                    <Field
                        name="ownerPrivateRole"
                        component={RFInputField}
                        label="Fonction"
                        type="text"
                    />
                    <Field
                        name="ownerPrivateAddress"
                        component={RFInputField}
                        label="Adresse"
                        type="text"
                        required
                    />
                    <Field
                        name="ownerPrivatePostalCode"
                        component={RFInputField}
                        label="Code postal"
                        type="text"
                        required
                    />
                    <Field
                        name="ownerPrivateCity"
                        component={RFInputField}
                        label="Commune"
                        type="text"
                        required
                    />
                    <Field
                        name="ownerPrivatePhone"
                        component={RFInputField}
                        label="Téléphone"
                        type="text"
                        required
                    />
                    <Field
                        name="ownerPrivateEmail"
                        component={RFInputField}
                        label="Email"
                        type="email"
                        required
                    />
                </Box>
                <Box>
                    <Typography
                        variant=" "
                        className={[classes.spacingUp, "form__title"].join(" ")}
                    >
                        Type de structure :
                    </Typography>
                    <Field
                        name="structureType"
                        component={RFSelectField}
                        id="structureType"
                        type="text"
                        displayEmpty
                    >
                        <MenuItem value="" disabled>
                            Type de structure :
                        </MenuItem>
                        {structureTypes.map(structure => (
                            <MenuItem
                                key={structure.value}
                                value={structure.value}
                            >
                                {structure.label}
                            </MenuItem>
                        ))}
                    </Field>
                </Box>
                <Box>
                    <Typography
                        variant=" "
                        className={[classes.spacingUp, "form__title"].join(" ")}
                    >
                        Appartenance à un réseau :
                    </Typography>
                    <br />
                    <Typography variant="caption">
                        Cochez-la ou les cases correspondantes (plusieurs choix
                        possibles)
                    </Typography>
                    <Field
                        name="networkTypes"
                        component={RFCheckboxGroup}
                        options={networkTypes}
                        label="Appartenance à un réseau"
                    />
                </Box>
                <Box>
                    <Typography
                        variant=" "
                        className={[classes.spacingUp, "form__title"].join(" ")}
                    >
                        {"S'agit-il de votre première participation ?"}
                    </Typography>
                    <Field
                        name="ownerFirstParticipation"
                        component={RFRadioButtonGroup}
                        type="text"
                    >
                        <FormControlLabel
                            value="1"
                            control={<Radio normalize={toInt} />}
                            label="Oui"
                        />
                        <FormControlLabel
                            value="0"
                            control={<Radio normalize={toInt} />}
                            label="Non"
                        />
                    </Field>
                </Box>
                <div>
                    {!valid && (
                        <Typography
                            variant="caption"
                            className={"form__submitValidation"}
                        >
                            Veuillez remplir tous les champs obligatoire pour
                            valider.
                        </Typography>
                    )}
                    <Button
                        type="button"
                        onClick={previousPage}
                        className={"form__previousButton"}
                    >
                        Précédent
                    </Button>
                    <Button
                        variant="contained"
                        type="submit"
                        className="form__button"
                        disabled={!valid}
                        data-testid="goToPage3"
                    >
                        Suivant
                    </Button>
                </div>
            </form>
        </>
    );
};
const mapStateToProps = state => ({
    regions: state.types.regions,
    natureTypes: state.types.natureTypes,
    networkTypes: state.types.networkTypes,
    structureTypes: state.types.structureTypes,
    error: state.formCustom.error,
    valid: state.formCustom.valid,
    loading: state.formCustom.loading,
    created: state.formCustom.created,
    dataLoading: state.types.loading,
    dataError: state.types.error,
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps),
    reduxForm({
        form: "event",
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate,
    })
)(SecondPage);
